import { useState } from "react";
import { Card, Row } from "react-bootstrap";
import { ProjectsWorkedOn } from "./details";

export default function ProjectDetails(props) {
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(2);
  const projects = ProjectsWorkedOn;

  let more = () => {
    setStart(start + 2);
    setEnd(end + 2);
  };

  let less = () => {
    setStart(start - 2);
    setEnd(end - 2);
  };

  let reset = () => {
    setStart(0);
    setEnd(2);
  };

  return (
    <>
      {projects.slice(start, end).map((item, key) => (
        <Card className="mt-md-3 mt-5" key={key}>
          <Card.Body className="text-secondary">
            <Row>
              <div className="col-md-4 mb-2 text-center">
                <Card.Img src={require("../../Images/" + item.imageName)} />
              </div>
              <div className="col-md text-light">
                <Row>
                  <div className="col-md-8 col">
                    <Card.Title>
                      {item.title}
                      <br />
                      <span className="tech-stack-details">Tech Stack: {item.madeWith}</span>
                    </Card.Title>
                  </div>
                  <div className="col-md-4 text-right actn-btn">
                    <div className="d-none d-md-block text-right">
                      <a className="btn btn-outline-danger" href={item.url}>
                        Details
                      </a>
                    </div>
                  </div>
                </Row>
                <Card.Text>
                  <br />
                  <span className="d-none d-md-block">{item.details}</span>
                </Card.Text>
              </div>
            </Row>
            <div className="d-block d-md-none mt-2 mt-md-0" id="actn-btn">
              <a className="btn btn-outline-light w-100" href={item.url}>
                Know More
              </a>
            </div>
          </Card.Body>
        </Card>
      ))}
      <div className="moreOptions text-right mt-2">
        {end === projects.length ? (
          <button className="text-light" onClick={reset} id="length">
            Reset
          </button>
        ) : (
          <></>
        )}
        {start >= 2 ? (
          <button className="text-danger" onClick={less} id="length">
            Prev
          </button>
        ) : (
          <></>
        )}
        {end < projects.length ? (
          <button className="text-light" onClick={more} id="length">
            Next
          </button>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
